import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import TrainIcon from "@mui/icons-material/Train";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import styled from "styled-components";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Box,Avatar,Hidden } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { toggleRegisterModal, toggleRegisterTravellerModal } from "../../reducers/UiReducer";
// import { Login } from "../login/Login";
const Icondivcss = styled.div`
  .icondiv {
    height: 60px;
    width: 100%;
    padding-right:10px;
    justify-content:space-between;
    margin: auto;
    background-color: white;
    display: flex;
    flex-direction: row;
    position: fixed;
    z-index: 100;
    text-align: center;
    box-shadow: 1px 3px 5px #c0c0c0;
    .icons {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 60%;

      p {
        padding: 0px;
        margin: -6px;
        color: #555454;
        font-size: 11px;
      }
      span {
        color: #a3a3a3;
        cursor: pointer;
      }
      span:hover {
        color: #2db0fc;
      }
      div:hover {
        color: #2db0fc;
      }
    }
  }
  .disnone {
    display: none;
  }
  .imgdiv {
    position: relative;
    left: 0px;
    img {
      width: 65%;
    }
  }
.login{
  position: relative;
  top: 10px;
  // left: 120px;
}
`;

export const Header = () => {
  const handlePopup = () => {
    const popup = document.getElementById("popup");
    popup.classList.toggle("active");
  };
  const dispatch = useDispatch();
  const history = useHistory();
  const [nav, setNav] = useState(false);
  const {agentlogin} =  useSelector((state)=>state.user)
  const handleChange = () => {
    if (window.scrollY >= 100) {
      setNav(true);
    } else {
      setNav(false);
    }
  };
  window.addEventListener("scroll", handleChange);
  return (
    <Icondivcss>
      <div className={nav ? "icondiv" : "disnone"}>
        <div className="imgdiv">
          <Link to="/">
            <img src={"https://nitish.musafirbazar.com/static/logo.png"} alt="Logo" style={{height:70,width:160}} />
          </Link>
        </div>
        <div className="icons">
          {/* <Hidden only={['xs']}>
          <div>
            <span>
              <FlightIcon style={{ fontSize: 30, padding: 4 }}></FlightIcon>
            </span>
            <p style={{fontSize:12}}>Flights</p>
          </div>
          </Hidden> */}
          
          {/* <div>
            <span>
              <HotelIcon style={{ fontSize: 30, padding: 4 }}></HotelIcon>
            </span>
            <p style={{fontSize:12}}>Hotels</p>
          </div> */}
          {/* <div>
            <span>
              <HomeWorkIcon style={{ fontSize: 30, padding: 4 }}></HomeWorkIcon>
            </span>
            <p style={{fontSize:12}}>Homestays</p>
          </div> */}
          {/* <div>
            <span>
              <HolidayVillageIcon
                style={{ fontSize: 30, padding: 4 }}
              ></HolidayVillageIcon>
            </span>
            <p style={{fontSize:12}}>Hoiday packages</p>
          </div> */}
          {/* <div>
            <span>
              <TrainIcon style={{ fontSize: 30, padding: 4 }}></TrainIcon>
            </span>
            <p style={{fontSize:12}}>Trains</p>
          </div> */}
          {/* <div>
            <span>
              <DirectionsBusFilledIcon
                style={{ fontSize: 30, padding: 4 }}
              ></DirectionsBusFilledIcon>
            </span>
            <p style={{fontSize:12}}>Buses</p>
          </div> */}
          {/* <div>
            <span>
              <LocalTaxiIcon
                style={{ fontSize: 30, padding: 4 }}
              ></LocalTaxiIcon>
            </span>
            <p style={{fontSize:12}}>Cabs</p>
          </div> */}
          {/* <div>
            <span>
              <CreditCardIcon
                style={{ fontSize: 30, padding: 4 }}
              ></CreditCardIcon>
            </span>
            <p style={{fontSize:12}}>Visa</p>
          </div> */}
          {/* <div>
            <span>
              <FlightTakeoffIcon
                style={{ fontSize: 30, padding: 4 }}
              ></FlightTakeoffIcon>
            </span>
            <p style={{fontSize:12}}>Charter flights</p>
          </div> */}
          {/* <div>
            <span>
              <DownhillSkiingIcon
                style={{ fontSize: 30, padding: 4 }}
              ></DownhillSkiingIcon>
            </span>
            <p style={{fontSize:12}}>Activities</p>
          </div> */}
        </div>
        <div className="login">
          {agentlogin?<Avatar onClick={()=>history.push('/dashboard')}
											style={{
												color: 'white',
												background: 'rgb(239, 51, 57)',
                        cursor:'pointer'
											}}>
											{agentlogin &&
												agentlogin.result &&
												agentlogin.result.result.name
													.match(/(\b\S)?/g)
													.join('')
													.match(/(^\S|\S$)?/g)
													.join('')
													.toUpperCase()}
										</Avatar>:<>
          <Box display='flex'>
          <Box style={{background:'darkslateblue',padding:8,borderRadius:10,cursor:'pointer'}}>
            <span style={{color:'white'}} onClick={()=>dispatch(toggleRegisterTravellerModal(true))}>Login</span>
          </Box>
          <Box style={{background:'darkslateblue',padding:8,borderRadius:10,marginLeft:10,cursor:'pointer'}}>
            <span style={{color:'white'}} onClick={()=>dispatch(toggleRegisterModal(true))}>SignUp</span>
          </Box>
          </Box></>}
        {/* <Login handleClick={handlePopup}/> */}
        </div>
      </div>
    </Icondivcss>
  );
};
